import React from "react";
import { Label } from "@/components/ui/label";

export function OptionGroup({ label, options, value, onChange, testId }) {
  return (
    <div>
      {label && <Label className="text-grises-600 mb-2 block">{label}</Label>}
      <div className="flex flex-wrap gap-2" data-testid={testId}>
        {options.map((opt) => {
          const active = value === opt;
          return (
            <button
              type="button"
              key={opt}
              data-testid={testId ? `${testId}-${opt}` : undefined}
              onClick={() => onChange(active ? "" : opt)}
              className={`px-3.5 py-1.5 rounded-full text-sm border transition-colors duration-200 ${
                active
                  ? "bg-borgona-700 border-borgona-700 text-blanco"
                  : "bg-blanco border-grises-300 text-grises-600 hover:border-borgona-500 hover:text-borgona-700"
              }`}
            >
              {opt}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export function MultiChips({ label, options, value = [], onChange, testId }) {
  const toggle = (opt) => {
    if (value.includes(opt)) onChange(value.filter((v) => v !== opt));
    else onChange([...value, opt]);
  };
  return (
    <div>
      {label && <Label className="text-grises-600 mb-2 block">{label}</Label>}
      <div className="flex flex-wrap gap-2" data-testid={testId}>
        {options.map((opt) => {
          const active = value.includes(opt);
          return (
            <button
              type="button"
              key={opt}
              data-testid={testId ? `${testId}-${opt}` : undefined}
              onClick={() => toggle(opt)}
              className={`px-3.5 py-1.5 rounded-full text-sm border transition-colors duration-200 ${
                active
                  ? "bg-dorado-500 border-dorado-500 text-negro font-medium"
                  : "bg-blanco border-grises-300 text-grises-600 hover:border-dorado-500"
              }`}
            >
              {opt}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export function SectionTitle({ children }) {
  return <h3 className="font-serif text-lg text-borgona-900 border-b border-grises-200 pb-2 mb-4 mt-2">{children}</h3>;
}
